import axios from "axios";

export const aggiornaDocumentoKpiApi = (idKpi, idDocumento, documento) => {
    return axios.put(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/documento/${idDocumento}`, documento);
}

export const getDocumentiKpiApi = (idKpi, filtro = '') => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/documento/`+ filtro);
}

export const getDocumentoKpiByIdApi = (idKpi, idDocumento) => {
    return axios.get(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/documento/${idDocumento}`);
}

export const deleteDocumentoKpiApi = (idKpi, idDocumento) => {
    return axios.delete(process.env.REACT_APP_API_ENDPOINT + `/api/sost/kpi/${idKpi}/documento/${idDocumento}`);
}